import React, { useState, useEffect } from 'react'
import { Modal, ModalBody, ModalFooter, Button, Alert } from 'reactstrap'
import { getInstructorIdData as getInstructorDataforStudents } from '../../lib/sessionscheduleview'
import { updateData } from '../../lib/sessionschedule'
import { InstructorScheduleTable } from './InstructorScheduleTable'
import ScheduleAddModal from './ScheduleAddModal'

const ScheduleStatusModal = ({ isOpen, toggle, instructorId, studentId, onSave, isDarkMode }) => {
	const [scheduleList, setScheduleList] = useState([])
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState('')
	const [isAddModalOpen, setIsAddModalOpen] = useState(false)

	const fetchScheduleData = async () => {
		if (!instructorId || !studentId) return

		try {
			setLoading(true)
			setError('')
			const data = await getInstructorDataforStudents(instructorId, studentId)
			setScheduleList(data || [])
		} catch (err) {
			console.error('Error fetching schedule data:', err)
			setError('Failed to load schedule data')
		} finally {
			setLoading(false)
		}
	}

	const changeTaskStatus = async (scheduleId, status) => {
		try {
			await updateData({
				id: scheduleId,
				status: status
			})
			fetchScheduleData()
			onSave?.()
		} catch (err) {
			console.error('Error updating status:', err)
			setError('Failed to update status')
		}
	}

	const handleScheduleAdded = () => {
		fetchScheduleData()
		onSave?.()
	}

	const toggleAddModal = () => setIsAddModalOpen((open) => !open)

	useEffect(() => {
		if (isOpen && instructorId && studentId) {
			fetchScheduleData()
		}
		if (!isOpen) {
			setIsAddModalOpen(false)
		}
	}, [isOpen, instructorId, studentId])

	return (
		<>
		<Modal isOpen={isOpen} toggle={toggle} size="lg" className={isDarkMode ? 'dark-modal' : ''}>
			<div className="modal-header">
				<div className="modal-title d-flex align-items-center justify-content-between flex-grow-1 min-w-0 me-3 gap-3">
					<span className="h5 mb-0 flex-shrink-0">Update Schedule Status</span>
					<Button
						color="primary"
						size="sm"
						type="button"
						className="flex-shrink-0"
						onClick={() => setIsAddModalOpen(true)}
					>
						Add New Date
					</Button>
				</div>
				<button type="button" className="btn-close" onClick={toggle} aria-label="Close" />
			</div>
			<ModalBody style={{ backgroundColor: isDarkMode ? '#262932' : '#fff', color: isDarkMode ? 'rgba(255, 255, 255, 0.8)' : 'inherit' }}>
				{error && (
					<Alert color="danger" className="alert-dismissible fade show">
						<strong>Error:</strong> {error}
						<Button type="button" className="btn-close" onClick={() => setError('')} aria-label="Close" />
					</Alert>
				)}

				{loading ? (
					<div className="text-center py-4">
						<div className="spinner-border" role="status">
							<span className="visually-hidden">Loading...</span>
						</div>
						<p className="mt-2">Loading schedule data...</p>
					</div>
				) : scheduleList.length === 0 ? (
					<div className="text-center py-4">No schedule data found for this student.</div>
				) : (
					<div className="table-responsive">
						<InstructorScheduleTable
							data={scheduleList}
							onStatusChange={changeTaskStatus}
							isDarkMode={isDarkMode}
							showIdColumn={false}
							showStudentColumn={false}
							paginationPerPage={10}
							paginationRowsPerPageOptions={[5, 10, 25, 50]}
							noDataComponent="No schedule data found for this student."
						/>
					</div>
				)}
			</ModalBody>
			<ModalFooter
				className="d-flex justify-content-end"
				style={{ backgroundColor: isDarkMode ? '#262932' : '#fff', borderTopColor: isDarkMode ? 'rgba(255, 255, 255, 0.1)' : '#dee2e6' }}
			>
				<Button color="secondary" onClick={toggle}>
					Close
				</Button>
			</ModalFooter>
		</Modal>
		<ScheduleAddModal
			isOpen={isAddModalOpen}
			toggle={toggleAddModal}
			instructorId={instructorId}
			studentId={studentId}
			onSave={handleScheduleAdded}
			isDarkMode={isDarkMode}
		/>
		</>
	)
}

export default ScheduleStatusModal
